import{getAugmentedNamespace as o}from"./_commonjsHelpers.js";import*as e from"../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js";var m=o(e);export{m as default};
//# sourceMappingURL=emotion-cache.browser.esm.js.map
